// Depends
import { route, group, subGroup, meta } from '@/helpers/routes'

import Create from './form/form'
import Index from './index/index'

const unitRoutes = [
  route('create', '/create', Create, meta('Adicionar nova unidade', true, 'guest')),
  route('edit', '/:id/edit', Create, meta('Editar Unidade', true, 'guest')),
  route('index', '/index', Index, meta('Lista de Unidades', true, 'guest'))
]

export default [
  ...group('/app', [
    ...subGroup('/unit', unitRoutes)
  ])
]



// WEBPACK FOOTER //
// ./src/app/dweller/unit/routes.js